<!-- ============ LOGGED OUT — split landing: brand story left, login right ============ -->
<section *ngIf="!authService.isLoggedIn()" class="landing">
  <div class="landing__intro">
    <div class="landing__glow" aria-hidden="true"></div>
    <img class="landing__bee" src="assets/bee-white.png" alt="" width="132" height="132">
    <div class="landing__copy">
      <p class="eyebrow eyebrow--light rise">MALS</p>
      <h1 class="landing__title">
        <span class="mask"><span>Mastering <em>Ascendancy</em></span></span>
        <span class="mask mask--2"><span>Leadership Spectrum</span></span>
      </h1>
      <p class="landing__lede rise rise--2">{{ 'Our web app with a specially developed assessment — the foundation of every analysis and development.' | t }}</p>
      <ul class="facets rise rise--3">
        <li><span class="facets__n">01</span>{{ 'Character' | t }}</li>
        <li><span class="facets__n">02</span>{{ 'Interaction' | t }}</li>
        <li><span class="facets__n">03</span>{{ 'Potential' | t }}</li>
      </ul>
    </div>
  </div>
  <div class="landing__login rise rise--2">
    <app-login (loggedIn)="onLoggedIn()"></app-login>
  </div>
</section>

<!-- ============ LOGGED IN — personal dashboard ============ -->
<div *ngIf="authService.isLoggedIn()" class="dash">
  <header class="dash__head rise">
    <p class="eyebrow">{{ roleLabel | t }}</p>
    <h1 *ngIf="!(authService.isAdmin())">{{ 'Welcome back, {name}!' | t: {name: this.user.firstName + ' ' + this.user.lastName} }}</h1>
    <h1 *ngIf="authService.isAdmin()">{{ 'Welcome back, {name}!' | t: {name: this.user.firstName} }}</h1>
  </header>

  <div class="dash__grid">
    <!-- questionnaire status -->
    <article class="tile tile--status rise rise--2" [class.tile--wide]="!(answered && topProcessTraits.length)">
      <div class="ring" [class.ring--done]="answered">
        <svg viewBox="0 0 120 120" aria-hidden="true">
          <circle class="ring__track" cx="60" cy="60" r="52"></circle>
          <circle class="ring__bar" cx="60" cy="60" r="52"
                  [attr.stroke-dasharray]="ringCircumference"
                  [attr.stroke-dashoffset]="progressLoaded ? ringOffset : ringCircumference"></circle>
        </svg>
        <span class="ring__value" *ngIf="progressLoaded">
          <i *ngIf="answered" class="bi bi-check-lg"></i>
          <ng-container *ngIf="!answered">{{ progress }}%</ng-container>
        </span>
      </div>
      <div class="tile__body" *ngIf="progressLoaded">
        <p class="eyebrow">{{ 'Questionnaire' | t }}</p>
        <ng-container *ngIf="answered">
          <h2 class="tile__title">{{ 'Questionnaire has been answered' | t }}</h2>
          <p class="tile__text">{{ 'You can view the evaluation of the questionnaire in your' | t }} <a routerLink="/profile">{{ 'Profile' | t }}</a>.</p>
          <a class="btn btn-primary" routerLink="/profile">{{ 'View full evaluation' | t }} <span aria-hidden="true">→</span></a>
        </ng-container>
        <ng-container *ngIf="!answered">
          <h2 class="tile__title">{{ 'Please fill out the questionnaire completely!' | t }}</h2>
          <p class="tile__text">{{ '{answered} of {total} questions answered' | t: {answered: answeredCount, total: totalQuestions} }}</p>
          <a class="btn btn-primary" routerLink="/questionnaire">
            {{ (answeredCount === 0 ? 'Start Questionnaire' : 'Continue questionnaire') | t }} <span aria-hidden="true">→</span>
          </a>
        </ng-container>
      </div>
    </article>

    <!-- result preview -->
    <article *ngIf="answered && topProcessTraits.length" class="tile tile--results rise rise--3">
      <p class="eyebrow">{{ 'Process Traits' | t }}</p>
      <h2 class="tile__title">{{ 'Your strongest process traits' | t }}</h2>
      <ol class="bars">
        <li *ngFor="let trait of topProcessTraits">
          <div class="bars__label">
            <span>{{ trait.traitEn | localized: trait.traitDe }}</span>
            <span class="bars__pct">{{ trait.resultPercentage * 100 | number: '1.0-0' }}%</span>
          </div>
          <div class="bars__track">
            <span class="bars__fill" [style.width.%]="100 * trait.resultPercentage / topProcessTraits[0].resultPercentage"></span>
          </div>
        </li>
      </ol>
      <a class="tile__link" routerLink="/profile">{{ 'View full evaluation' | t }} <span aria-hidden="true">→</span></a>
    </article>

    <!-- quick access -->
    <article class="tile tile--links rise rise--3">
      <p class="eyebrow">{{ 'Quick access' | t }}</p>
      <nav class="quick">
        <a routerLink="/profile"><i class="bi bi-person"></i>{{ 'Profile' | t }}</a>
        <a routerLink="/questionnaire"><i class="bi bi-ui-checks"></i>{{ 'Questionnaire' | t }}</a>
        <a *ngIf="authService.isAdmin()" routerLink="/user-admin"><i class="bi bi-people"></i>{{ 'User Administration' | t }}</a>
        <a *ngIf="authService.isAdmin()" routerLink="/departments"><i class="bi bi-diagram-3"></i>{{ 'Departments' | t }}</a>
        <a *ngIf="authService.isManager()" routerLink="/projects"><i class="bi bi-people-fill"></i>{{ 'Project Teams' | t }}</a>
        <a *ngIf="authService.isManager()" routerLink="/my-department"><i class="bi bi-database"></i>{{ 'My Department' | t }}</a>
      </nav>
    </article>

    <!-- back to the website -->
    <a class="tile tile--ink rise rise--4" [href]="globals.websiteUrl">
      <img src="assets/bee-white.png" alt="" width="56" height="56">
      <span class="tile--ink__name">Mastering Emotions</span>
      <span class="tile--ink__cta">{{ 'Learn more about us' | t }} <span aria-hidden="true">↗</span></span>
    </a>
  </div>
</div>
